import { useEffect } from "react"

import { reduceTree } from "shared/lib/treeUtils"
import { ProjectChild, isProjectProductPosition } from "shared/types/Project"

import { useProductObjCache } from "entities/products/model/store/useProductObjCache"

export function useProjectChildrenCache(
  children?: ProjectChild[] | null,
  options?: { skip?: boolean }
) {
  const { buildCacheForTypes } = useProductObjCache()

  useEffect(() => {
    if (!options?.skip) {
      const productTypes = reduceTree(
        children,
        (current, child) => {
          if (isProjectProductPosition(child)) {
            current.add(child.variantKey.split("-")[0])
          }
          return current
        },
        new Set<string>()
      )
      buildCacheForTypes(Array.from(productTypes))
    }
  }, [options?.skip, children, buildCacheForTypes])
}
